import { notifyParent } from 'Helpers/notifyParent'
import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
  Flex
} from 'mailup-web-components'

import { useIntl } from 'react-intl'

const Footer = () => {
  const intl = useIntl()
  const handleClick = () => {
    notifyParent('redirectMainFrame', [`/console/GestoreContenutiEsterni.aspx`])
  }
  return (
    <Flex justifyContent='flex-end' margin='24px 0'>
      <Button
        kind={BUTTON_VARIANT_PRIMARY}
        size={BUTTON_SIZE_LG}
        onClick={handleClick}
        data-mu-test='footer-button'
      >
        {intl.formatMessage({ id: 'Load.DynamicContentList.AddNew' })}
      </Button>
    </Flex>
  )
}

export default Footer
